import "@/App.css";
import "@/styles/site.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/site/SiteContext";
import Nav from "@/site/Nav";
import Footer from "@/site/Footer";
import EnquiryPanel, { FlyLayer } from "@/site/EnquiryPanel";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import CustomOem from "@/pages/CustomOem";
import ProductIndex from "@/pages/ProductIndex";
import Contact from "@/pages/Contact";

/* steel panel wipe between pages */
function Wipe() {
  const loc = useLocation();
  return (
    <div className="wipe" key={loc.pathname} aria-hidden="true">
      <i /><i />
    </div>
  );
}

function ScrollTop() {
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return null;
}

function Shell() {
  return (
    <>
      <Wipe />
      <ScrollTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/product/:code" element={<ProductDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/custom-oem" element={<CustomOem />} />
        <Route path="/product-index" element={<ProductIndex />} />
        <Route path="/index" element={<Navigate to="/product-index" replace />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      <EnquiryPanel />
      <FlyLayer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <Toaster theme="dark" position="bottom-right" />
        <Shell />
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
